<template>
  <div>
    <small>Etapa 3 de 5</small>
    <h5>Informações profissionais</h5>

    <div class="checkbox mt-0 mb-4 d-flex flex-column justify-content-center">
      <label>
        <input
          type="checkbox"
          v-model="ocupacaoCheck"
          @click="ocupacaoCheck = !ocupacaoCheck"
          v-on:change="updateValueCheckbox($event, 'ocupacaoCheck')"
        />
        <i class="helper" style="top: 3px;"></i>Você trabalha atualmente?
      </label>
    </div>
    <b-form-group class="w-100 mt-1" v-if="ocupacaoCheck">
      <input
        type="text"
        :value="ocupacao"
        required="required"
        v-on:change="updateValue($event, 'ocupacao')"
      />
      <label for="input" class="control-label" style="font-size: 90%;">Especifique a ocupação</label>
      <i class="bar"></i>
    </b-form-group>

    <div class="checkbox mt-0 mb-4 d-flex flex-column justify-content-center">
      <label>
        <input
          type="checkbox"
          v-model="negocioProprioCheck"
          @click="negocioProprioCheck = !negocioProprioCheck"
          v-on:change="updateValueCheckbox($event, 'negocioProprioCheck')"
        />
        <i class="helper" style="top: 3px;"></i>Você possui ou já possuiu um
        negócio próprio?
      </label>
    </div>

    <b-form-group class="w-100 mt-1" v-if="negocioProprioCheck">
      <input
        type="text"
        :value="negocioProprio"
        required="required"
        v-on:change="updateValue($event, 'negocioProprio')"
      />
      <label for="input" class="control-label" style="font-size: 90%;">Especifique o ramo</label>
      <i class="bar"></i>
    </b-form-group>

    <div class="checkbox mt-0 mb-4 d-flex flex-column justify-content-center">
      <label>
        <input
          type="checkbox"
          v-model="tipoProdutoCheck"
          @click="tipoProdutoCheck = !tipoProdutoCheck"
          v-on:change="updateValueCheckbox($event, 'tipoProdutoCheck')"
        />
        <i class="helper" style="top: 3px;"></i>Você já trabalhou com
        vendas?
      </label>
    </div>

    <b-form-group class="w-100 mt-1" v-if="tipoProdutoCheck">
      <input
        type="text"
        :value="tipoProduto"
        required="required"
        v-on:change="updateValue($event, 'tipoProduto')"
      />
      <label for="input" class="control-label" style="font-size: 90%;">Com qual tipo de produto?</label>
      <i class="bar"></i>
    </b-form-group>

    <div class="checkbox mt-0 mb-4 d-flex flex-column justify-content-center">
      <label>
        <input
          type="checkbox"
          v-model="experienciaCheck"
          @click="experienciaCheck = !experienciaCheck"
          v-on:change="updateValueCheckbox($event, 'experienciaCheck')"
        />
        <i class="helper" style="top: 3px;"></i>Você tem experiência com
        Gestão de Equipes / Pessoas?
      </label>
    </div>

    <b-form-group class="w-100 mt-1" v-if="experienciaCheck">
      <input
        type="text"
        :value="experiencia"
        required="required"
        v-on:change="updateValue($event, 'experiencia')"
      />
      <label for="input" class="control-label" style="font-size: 90%;">Fale sobre...</label>
      <i class="bar"></i>
    </b-form-group>

    <div class="checkbox mt-0 mb-4 d-flex flex-column justify-content-center">
      <label>
        <input
          type="checkbox"
          v-model="experienciaSegmentoCheck"
          @click="experienciaSegmentoCheck = !experienciaSegmentoCheck"
          v-on:change="updateValueCheckbox($event, 'experienciaSegmentoCheck')"
        />
        <i class="helper" style="top: 3px;"></i>Voce tem experiência no
        Segmento automotivo?
      </label>
    </div>

    <b-form-group class="w-100 mt-1" v-if="experienciaSegmentoCheck">
      <input
        type="text"
        :value="experienciaSegmento"
        required="required"
        v-on:change="updateValue($event, 'experienciaSegmento')"
      />
      <label for="input" class="control-label" style="font-size: 90%;">Fale sobre...</label>
      <i class="bar"></i>
    </b-form-group>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: [
    "ocupacao",
    "ocupacaoCheck",
    "negocioProprio",
    "negocioProprioCheck",
    "tipoProduto",
    "tipoProdutoCheck",
    "experiencia",
    "experienciaCheck",
    "experienciaSegmento",
    "experienciaSegmentoCheck"
  ],
  methods: {
    updateValue(event, data) {
      this.$emit(`update:${data}`, event.target.value);
    },
    updateValueCheckbox(event, data) {
      this.$emit(`update:${data}`, event.target.checked);
    }
  }
};
</script>

<style lang="scss" scoped>
h5 {
  margin-bottom: 30px;
}
</style>